import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import React from 'react';
import globalStyles from '../../global';
import { useTranslation } from 'react-i18next';
import { servicesConfig } from '../globalCountries/config/servicesConfig';
import { useNavigate } from 'react-router-dom';

const ServicesSection = ({ countryCode = "uae" }) => {
  const { t } = useTranslation();
  const config = servicesConfig[countryCode] || servicesConfig.uae;
  const navigate = useNavigate(); // Initialize useNavigate
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const handleViewAllClick = () => {
    navigate('/services'); // Programmatically navigate to /services
  };

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.contentWrapper}>
        <Box sx={styles.titleSection}>
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                sm: "row",
                xs: "column",
              },
              justifyContent: "space-between",
              width: "100%",
              
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: {
                    md: "40px",
                    sm: "28px",
                    xs: "24px",
                  },
                  lineHeight: "auto",
                  letterSpacing: "1%",
                  fontWeight: 600,
                  color: globalStyles.colors.head_green,
                  fontFamily: globalStyles.fonts.primaryUAE,
                }}
              >
                {t("servicesHome.heading")}
              </Typography>
              <Typography sx={styles.subtitle}>
                {t("servicesHome.subHeadingSr")}
              </Typography>
            </Box>
            <Button sx={styles.viewAllButton} onClick={handleViewAllClick}>
              {" "}
              {/* Add onClick handler */}
              {t("servicesHome.buttonText")}
            </Button>
          </Box>
        </Box>

        <Box sx={styles.servicesGrid}>
          {config.services.map((service, index) => (
            <Box
              key={index}
              sx={{
                ...styles.serviceCard,
                // Center the last card in mobile view when it's the 5th card
                gridColumn: {
                  xs:
                    config.services.length === 5 && index === 4
                      ? "1 / -1"
                      : "auto",
                  sm: "auto",
                  md: "auto",
                },
                justifySelf: {
                  xs:
                    config.services.length === 5 && index === 4
                      ? "center"
                      : "auto",
                  sm: "auto",
                  md: "auto",
                },
                minWidth: {
                  xs:
                    config.services.length === 5 && index === 4
                      ? "54%"
                      : "100%",
                  sm: "100%",
                  md: "100%",
                },
              }}
            >
              <Box
                component="img"
                src={`${imageBaseUrl}${service.icon}`}
                alt={t(`servicesHome.serviceItems.${service.id}.title`)}
                sx={styles.serviceIcon}
              />
              <Typography sx={styles.serviceTitle}>
                {t(`servicesHome.serviceItems.${service.id}.title`)}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainContainer: {
    width: "100%",
    backgroundColor: globalStyles.colors.white,
    pt: 4,
    pb: 6,
  },
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: { xs: "0 16px", md: "0 24px" },
  },
  header: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", md: "center" },
    mb: 4,
  },
  titleSection: {
    marginBottom: { xs: "12px", md: "12px" }, // Reduced margin on mobile
  },
  subtitle: {
    color: globalStyles.colors.medium_gray,
    marginBottom: "24px",
    fontSize: {
      sm: "18px",
      xs: "14px",
    },
    fontFamily: globalStyles.fonts.primary,
    lineHeight: "auto",
    letterSpacing: "1%",
  },
  viewAllButton: {
    color: globalStyles.colors.uclean_green,
    border: `1px solid ${globalStyles.colors.uclean_green}`,
    borderRadius: "10px",
    px: 4,
    py: 1,
    textTransform: "none",
    fontFamily: globalStyles.fonts.primary,
    fontSize: {
      sm: "18px",
      xs: "14px",
    },
    mb: { xs: 2, sm: 4 }, // More margin on mobile
    fontWeight: 600,
    height: "fit-content",
    width: { xs: "100%", sm: "auto" }, // Full width on mobile
    mt: { xs: 2, sm: 0 }, // Add top margin on mobile
    "&:hover": {
      backgroundColor: globalStyles.colors.uclean_green,
      color: globalStyles.colors.white,
    },
  },
  servicesGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(5, 1fr)",
    },
    gap: 1,
  },
  serviceCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    py: 2.5,
    px: 2,
    borderRadius: "12px",
    border: `1px solid ${globalStyles.colors.border_gray}`,
    transition: "all 0.2s ease",
    backgroundColor: "white", // Set default background color
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      borderColor: globalStyles.colors.army_green,
      backgroundColor: globalStyles.colors.base_light, // Apply hover background color to all cards
    },
  },
  serviceIcon: {
    height: {
      xs: "68px",
      sm: "78px",
    },
    width: "auto",
    marginBottom: "16px",
    objectFit: "contain",
  },
  serviceTitle: {
    color: globalStyles.colors.army_green,
    fontSize: {
      sm: "20px",
      xs: "16px",
    },
    fontWeight: 500,
    fontFamily: globalStyles.fonts.primary,
    textAlign: "center",
    letterSpacing: "0%",
    lineHeight: "auto",
  },
};

export default ServicesSection;
